export default __webpack_public_path__ + "static/media/Aleksandrina.88d19b5b.png";